import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UtilityService } from '../../core/services/utility_functions/utility_functions.service';
import { MapPreviewOptions, Provider, Type } from '../location-preview/location-preview.interface';
import { LocationPreviewService } from '../location-preview/location-preview.service';

@Component({
  selector: 'app-gallery-details',
  templateUrl: './gallery-details.component.html',
  styleUrls: ['./gallery-details.component.scss']
})
export class GalleryDetailsComponent implements OnInit, OnChanges {

  @Input()data: any;
  mapOptions: MapPreviewOptions = {
    module: '',
    moduleUid: '',
    coords: [],
    width: 0,
    height: 0,
    zoom: 0,
    provider: Provider.GOOGLE,
    type: Type.IMAGE
  };
  dateTimeFormat: any;
  constructor(
    private _utilityService: UtilityService,
    private _locationPreviewService: LocationPreviewService
  ) { }

  getAttachmentType(url: string): string{
    const type = url.split('.').pop();
    return type.toLocaleUpperCase();
  }

  ngOnInit(): void {
    this.dateTimeFormat = this._utilityService.dateTimeFormat;
    if(this.data?.geo_cordinates){
      this.mapOptions = {
        module:'',
        moduleUid:'',
        coords: this.data?.geo_cordinates,
        extraClass: '',
        width: 500,//send without units
        height: 800,
        zoom: 19,
        provider: Provider.GOOGLE,
        type: Type.IMAGE
      };
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

}
